import { useLocal, LocaleType } from '@da-vinci/locales'

const LOCAL_KEY = 'COPY_MACHINE_LOCAL__'
const { currentLocal, i18n, t } = useLocal({
  LOCAL_KEY,
  oneLang: LocaleType.zhCN,
})

export { LocaleType, currentLocal, i18n, t }
